module.exports = __webpack_public_path__ + "static/media/ipro-offer.1c560025.svg";